import axios from 'axios';
import Environment from '../../utils/Environment';
import { unwrapResponse } from './apiResponse';

export interface User {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
    admin: boolean;
}

export interface UserPayload {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    adminInd: number;
    statusInd: number;
    createUserId: string;
}

const toPayload = (user: User, actorUserId: string): UserPayload => ({
    userId: user.userId,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    adminInd: user.admin ? 1 : 0,
    statusInd: user.active ? 1 : 0,
    createUserId: actorUserId,
});

export const listUsers = async (): Promise<User[]> => {
    const baseURL = Environment.getHubUsersAPI();
    const response = await axios.get(baseURL);
    const data = unwrapResponse<any[]>(response.data);
    return data.map((u) => ({
        ...u,
        admin: u.admin !== undefined ? Boolean(u.admin) : u.adminInd === 1,
        active: u.active !== undefined ? Boolean(u.active) : u.statusInd === 1,
    }));
};

export const getUser = async (id: string): Promise<User> => {
    const baseURL = Environment.getHubUsersAPI();
    const response = await axios.get(`${baseURL}/${encodeURIComponent(id)}`);
    return unwrapResponse<User>(response.data);
};

export const createUser = async (user: User, actorUserId: string): Promise<User> => {
    const baseURL = Environment.getHubUsersAPI();
    const response = await axios.post(baseURL, toPayload(user, actorUserId));
    return unwrapResponse<User>(response.data);
};

export const updateUser = async (id: string, user: User, actorUserId: string): Promise<User> => {
    const baseURL = Environment.getHubUsersAPI();
    const response = await axios.post(
        `${baseURL}/${encodeURIComponent(id)}/update`,
        toPayload(user, actorUserId)
    );
    return unwrapResponse<User>(response.data);
};

export const deleteUser = async (id: string): Promise<void> => {
    const baseURL = Environment.getHubUsersAPI();
    await axios.post(`${baseURL}/${encodeURIComponent(id)}/delete`);
};
